export const RECOMMENDATIONS_CONFIG_ID = "KeywordsGeneratorV2";
export const TABLE_SELECTION_KEY = "monitor_keywords_page_table";
export const DEFAULT_NAVIGATION_STATE = "organicsearch_keywordAnalysis_overview_2";
export const DEFAULT_CONFIG_ID = "KeywordAnalysis";
